import { useCallback } from "react";

import { ReferredApplicantData } from "config";
import { useAppDispatch, useAppSelector } from "store";
import { createApplicationReferral } from "store/actions/producerManagement";
import { getAffiliateSessionData } from "utils/affiliateEstimate";

export const useCreateApplicationReferral = () => {
  const dispatch = useAppDispatch();
  const utmCampaign = useAppSelector(state => state.analyticsTracker.utm.utm_campaign);

  const createProducerApplicationReferral = useCallback(async () => {
    const affiliateSessionData = getAffiliateSessionData<ReferredApplicantData>();

    const referralCode = affiliateSessionData["referral_token"] || utmCampaign;
    const externalId = affiliateSessionData["external_id"];

    return await dispatch(
      createApplicationReferral({
        referralCode: referralCode,
        externalId: externalId,
      })
    );
  }, [dispatch, utmCampaign]);

  return createProducerApplicationReferral;
};
